<template>
<div class="col-12 tabs-menu">
  <router-link :to="{ name: 'faucets-list', params: { id_group: id_group }}">
    <div class="menu-tab" v-bind:class="{active: isFaucets}">Краны</div>
  </router-link>
  <router-link :to="{ name: 'sensors-list', params: { id_group: id_group }}">
    <div class="menu-tab" v-bind:class="{active: isSensors}">Датчики</div>
  </router-link>
  <router-link :to="{ name: 'group-settings', params: { id_group: id_group }}">
    <div class="menu-tab" v-bind:class="{active: isGroupSettings}">Настройки</div>
  </router-link>
  <router-link :to="{ name: 'history', params: { id_group: id_group }}">
    <div class="menu-tab" v-bind:class="{active: isHistory}">История</div>
  </router-link>
  <router-link :to="{ name: 'notification-users', params: { id_group: id_group }}">
    <div class="menu-tab" v-bind:class="{active: isNotificationUsers}">Оповещения</div>
  </router-link>
</div>
</template>

<script>
import {
  store
} from '@/store'

export default {
  name: 'group-menu-block',
  created() {},
  data() {
    return {
        id_group: this.$store.getters.id_group
    }
  },
  props: ['page'],
  computed: {
    isFaucets: function () {
      return this.page == 'faucets-list'
    },
    isSensors: function () {
      return this.page == 'sensors-list'
    },
    isGroupSettings: function () {
      return this.page == 'group-settings'
    },
    isHistory: function () {
      return this.page == 'history'
    },
    isNotificationUsers: function () {
      return this.page == 'notification-users'
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/group_menu.vue